export function formatPrice(price: number): string {
  // format price to Thai Baht without decimal
  return price.toLocaleString('th-TH', {
    currency: 'THB',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency',
  })
}
